import React from 'react'
import PropTypes from 'prop-types'
import Header from './Header'
import { Button } from 'loyal-react'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

const ShippingTime = props => {
  const items = props.cart.items
  const shippingTime = props.cart.shipping

  return (
    <div className={`${props.step === 2 ? 'container-shippingtime-step col-12 box-steps-new bg-white step_active_container' : 'container-shippingtime-step col-12 box-steps-new bg-white step_inactive_container'}`} data-index='2'>
      <Header
        step={props.step}
        handleStepChange={props.handleStepChange}
        description={props.customer.name}
      />
      {
        (props.step === 2)
          ? <div className='row px-0 pb-2 space-m'>
            <div className='shippingtime-info px-3 col-12 border-top border-color-ui-2'>
              <div className='shippingtime-shipping border-dashed-bottom border-color-ui-2 mt-2'>
                <div className='shippingtime-datails details-mob'>
                  <p className='delivery-forecast'>Previsão de entrega:<span>{shippingTime.maxDeliveryDate}</span></p>
                  <p className='price-freight'>Valor do frete:
                    <CatalogCurrencyLabel
                      checkCashOnly
                      price={{
                        points: shippingTime.total,
                        cash: shippingTime.totalCash
                      }}
                    />
                  </p>
                </div>
              </div>
              {items.map((item) => (
                <div className='shippingtime-item mt-2'>
                  <img className='item-image' src={item.imageUrl} alt='' aria-hidden='true' />
                  <div className='shippingtime-description'>
                    <span className='item-name'>{item.name}</span>
                    <p className='item-price-quantity'>
                      <CatalogCurrencyLabel
                        checkCashOnly
                        price={{
                          points: item.points && (item.points.sellingPrice * item.quantity),
                          cash: item.cash && (item.cash.sellingPrice * item.quantity)
                        }}
                      /> x
                      {item.quantity > 1 ? <span> {item.quantity} unidades</span> : <span> {item.quantity} unidade</span>}
                    </p>
                  </div>
                </div>
              ))}

              <div className='col-12 offset-md-12 col-md-12 mt-2'>
                <Button
                  className='btn btn-sm btn-featured btn-continuar'
                  onClick={() => { props.handleStepChange(3) }}
                  text='Continuar para o pagamento'
                  id='next-button'
                />
              </div>
            </div>
          </div>
          : ''
      }
    </div>
  )
}

ShippingTime.propTypes = {
  step: PropTypes.number.isRequired,
  handleStepChange: PropTypes.func.isRequired,
  customer: PropTypes.object,
  cart: PropTypes.object
}

export default ShippingTime



// WEBPACK FOOTER //
// ./src/features/Checkout/ShippingTime/ShippingTime.js